<script setup lang="ts">
/**
 * Minimal centered canvas for standalone surfaces (e.g. /login). No chrome.
 */
</script>

<template>
  <div class="min-h-screen bg-canvas">
    <slot />
  </div>
</template>
